import { getType, Reducer } from 'typesafe-actions'

import { withLoadingReducer } from '../../../redux/loading'

import { AccountUserActions } from './actions'
import { AccountUserState, RegistrationType, UserType } from './types'

export const initialState: AccountUserState = {
  data: {
    crifAccount: {
      givenName: '',
      familyName: '',
      companyName: '',
      email: '',
      phone: '',
      languageCode: '',
      userType: UserType.Company,
      contactAuthorization: {
        newsletter: false,
        communications: false,
        messages: false
      }
    },
    accounting: {
      billingAddress: {
        address: '',
        city: '',
        zipCode: '',
        province: '',
        provinceCode: '',
        country: '',
        countryCode: ''
      },
      invoicing: {
        recipientCode: ''
      },
      registrationType: RegistrationType.Light,
      taxId: ''
    }
  }
}

export const reducer: Reducer<AccountUserState, AccountUserActions> = (
  state = initialState,
  action
): AccountUserState => {
  switch (action.type) {
    case getType(AccountUserActions.setData): {
      return {
        ...state,
        data: action.payload
      }
    }
    case getType(AccountUserActions.setBillingData): {
      return {
        ...state,
        data: {
          ...state.data,
          accounting: {
            ...action.payload
          }
        }
      }
    }
    default:
      return state
  }
}

export const accountUserReducer = withLoadingReducer(reducer, 'accountUser', initialState)
